import { Component } from 'react';
import throttle from 'lodash/throttle';
import autobind from 'class-autobind';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

// This value corresponds to how frequently we allow the firehose of 
// human-initiated events to call our smarter analytics-throttling code
const INTERACTION_THROTTLE_INTERVAL_MS = 1000;

/**

  Observes human interactions in a throttled way and reports that *an*
  interaction occurred to the analytics system (which has its own
  internal throttling to determine when (or whether) to emit the event.

  There's some subtlety here in that the analytics the business cares about is
  "time on page". Whether or not "time on page" means "an open browser window"
  or "a user interacts with the page" is debatable but irrelevant here.
  We choose to use human-initiated events (rather than setTimeout) because: 
  (1) the behavior is well understood--i.e., a person is doing something to the 
  tab rather than the JS interpreser is "doing something maybe?" 
  (2) we dont have to worry about the "a page left open over the weekend 
  hits our analytics endlessly" problem.

*/
class ActivityObserverManager extends Component {

  constructor(props) {
    super(props);

    this.handleActivityThrottled = throttle(
      // This throttling is for page performance, the analytics system performance
      // event-volume reduction throttling
      this.handleActivity, 
      INTERACTION_THROTTLE_INTERVAL_MS, 
      { leading: false, trailing:true }
    );

    autobind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleActivityThrottled, false);
    document.addEventListener('mousemove', this.handleActivityThrottled, false);
    window.addEventListener('scroll', this.handleActivityThrottled, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleActivityThrottled);
    document.removeEventListener('mousemove', this.handleActivityThrottled);
    window.removeEventListener('scroll', this.handleActivityThrottled);
  }

  shouldComponentUpdate() {
    return false;
  }

  handleActivity() {
    getTracker().handleThrottledInteractionHeartbeat();
  }

  render() {
    return this.props.children;
  }
}


export default ActivityObserverManager;